import React from 'react';
import './MobilePricingSection.css';

export default function MobilePricingSection() {
  return (
    <section 
      id="pricing" 
      className="m-pricing-section"
    >
      <div className="m-pricing-container">
        <h2 className="m-pricing-title">Choose Your Plan</h2>
        <div className="m-pricing-cards">
          {/* Casual (Free) Tier Card */}
          <div className="m-plan-card" data-testid="plan-free">
            <div className="m-plan-mascot">
              <img 
                src="/scout_images/Scout_Thumbsup.png" 
                alt="Scout mascot for Casual plan" 
                className="m-mascot-image"
              />
            </div>
            <div className="m-plan-body">
              <h3 className="m-plan-title">Casual</h3>
              <p className="m-plan-identity">For staying organized without friction</p>
              <div className="m-plan-price">
                <span className="m-price-amount">$0</span>
                <span className="m-price-period"> / month</span>
              </div>
              <div className="m-plan-divider"></div>
              <ul className="m-plan-features">
                <li><span className="m-check">✓</span>Syllabus upload with automatic calendar syncing and deadline timeline</li>
                <li><span className="m-check">✓</span>Assignments and class events automatically organized by course</li>
                <li><span className="m-check">✓</span>Course materials stored and grouped by class</li>
                <li><span className="m-check">✓</span>Central dashboard to view classes, deadlines, and progress</li>
              </ul>
              <p className="m-plan-best-for">Students who want structure without overthinking it.</p>
            </div>
          </div>

          {/* Locked-In (Basic) Plan Card */}
          <div className="m-plan-card m-plan-popular" data-testid="plan-basic">
            <div className="m-most-popular-badge">
              Most Popular
            </div>
            <div className="m-plan-mascot">
              <img 
                src="/scout_images/Scout_Mid.png" 
                alt="Scout mascot for Locked-In plan" 
                className="m-mascot-image"
              />
            </div>
            <div className="m-plan-body">
              <h3 className="m-plan-title">Locked-In</h3>
              <p className="m-plan-identity">For students who don't miss deadlines</p>
              <div className="m-plan-price">
                <span className="m-price-amount">$4.99</span>
                <span className="m-price-period"> / month</span>
              </div>
              <div className="m-plan-divider"></div>
              <ul className="m-plan-features">
                <li><span className="m-check">✓</span>All organization and planning features from the Casual plan</li>
                <li><span className="m-check">✓</span>AI-generated quizzes from your course materials</li>
                <li><span className="m-check">✓</span>AI-generated flashcards from your course materials</li>
                <li><span className="m-check">✓</span>Fast review and study tools built from what you upload</li>
              </ul>
              <p className="m-plan-best-for">Students who are serious about grades and consistency.</p>
            </div>
          </div>

          {/* All-Gas (Pro) Plan Card */}
          <div className="m-plan-card" data-testid="plan-pro">
            <div className="m-plan-mascot">
              <img 
                src="/scout_images/Scout_Extreme.png" 
                alt="Scout mascot for All-Gas plan" 
                className="m-mascot-image"
              />
            </div>
            <div className="m-plan-body">
              <h3 className="m-plan-title">All-Gas</h3>
              <p className="m-plan-identity">For total immersion and zero excuses</p>
              <div className="m-plan-price">
                <span className="m-price-amount">$11.99</span>
                <span className="m-price-period"> / month</span>
              </div>
              <div className="m-plan-divider"></div>
              <ul className="m-plan-features">
                <li><span className="m-check">✓</span>All planning and AI study tools from the Locked-In plan</li>
                <li><span className="m-check">✓</span>Audiobooks generated from your course materials</li>
                <li><span className="m-check">✓</span>AI-generated study podcasts from your classes</li>
                <li><span className="m-check">✓</span>Learn hands-free while commuting, training, or walking</li>
              </ul>
              <p className="m-plan-best-for">Students who want every possible edge.</p>
            </div>
          </div>
        </div>
        
        <div className="m-pricing-footer">
          <div className="m-pricing-beta-label">Beta Pricing</div>
          <p className="m-pricing-beta-text">
            Early access pricing while DocuHounds is in beta. Features may expand over time.
          </p>
        </div>
      </div>
    </section>
  );
}
